import(/* webpackMode: "eager" */ "/var/www/telesky/src/app/not-found.tsx");
